import apiClient from "./apiClient";

export async function listCustomers(
  companyId: string,
  options: {
    search?: string;
    type?: string;
    customer_type_id?: string;
    limit?: number;
    offset?: number;
  } = {},
) {
  const params = new URLSearchParams();
  if (options.search) params.set("search", options.search);
  if (options.type) params.set("type", options.type);
  if (options.customer_type_id)
    params.set("customer_type_id", options.customer_type_id);
  if (options.limit) params.set("limit", options.limit.toString());
  if (options.offset) params.set("offset", options.offset.toString());
  const response = await apiClient.get(
    `/api/companies/${companyId}/customers?${params.toString()}`,
  );
  return response as { customers: any[]; total: number };
}

export async function getCustomer(companyId: string, customerId: string) {
  const response = await apiClient.get(
    `/api/companies/${companyId}/customers/${customerId}`,
  );
  return response.customer;
}

export async function createCustomer(companyId: string, customerData: any) {
  const response = await apiClient.post(
    `/api/companies/${companyId}/customers`,
    customerData,
  );
  return response.customer;
}

export async function updateCustomer(
  companyId: string,
  customerId: string,
  updates: any,
) {
  const response = await apiClient.put(
    `/api/companies/${companyId}/customers/${customerId}`,
    updates,
  );
  return response.customer;
}

export async function deleteCustomer(companyId: string, customerId: string) {
  const response = await apiClient.delete(
    `/api/companies/${companyId}/customers/${customerId}`,
  );
  return response.customer;
}

export async function archiveCustomer(companyId: string, customerId: string) {
  const response = await apiClient.post(
    `/api/companies/${companyId}/customers/${customerId}/archive`,
  );
  return response.customer;
}

const customersService = {
  listCustomers,
  getCustomer,
  createCustomer,
  updateCustomer,
  deleteCustomer,
  archiveCustomer,
};

export default customersService;
